import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Examination() { 
  useEffect(() => {
    document.title = 'Examination -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Examination</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Examination</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <ul className="mainlist">
                    <li> Any leave applied for during the tests or examinations, will be at the risk of the students and will not be taken into consideration in determining promotion.</li>
                    <li>Students will be disqualified if they are detected giving,  obtaining or attempting to give or obtain unfair assistance during tests or examinations.</li>
                    <li>A student who makes any alteration in the marks entered in the report card or the test/ examination scripts will be asked to leave the school.</li>
                    <li>Arrears in fees must be cleared before the respective test (s) or examination(s) failing which students will not be permitted to appear in the test(s)/examination.</li>
                    <li>Students suffering from sickness and medically unfit will not be permitted to appear in tests and examinations. Parents are requested not to send such students to school. They can submit an application along with a medical certificate for their absence.</li>
               </ul>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Examination;
